import { SOGetRequirement } from '../requirement/so-get-requirement';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {ENRequirementStatus} from '../../enums';


export class SOPutRequirement {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
    public active: boolean = null,
    public currentStatus: ENRequirementStatus = null,
    public parent: SOGetRequirement = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutRequirement(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'active' in params ? params.active : null,
      'currentStatus' in params ? params.currentStatus : null,
      'parent' in params ? params.parent : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
